// The legacy accounts SSH key endpoints (`/ssh_keys`, and the `ssh_keys` field
// of the legacy `/me` payload). Kept behind ENABLE_SSH_KEYS_API until every
// vendor is on the new API; delete this file along with the flag.
import { apiProxyRequest } from "Api/apiProxyRequest";

import type { LegacySshKey, SshKey } from "./types";

export type { LegacySshKey } from "./types";

/**
 * Adapts a legacy key to the shape the store and the UI use, so only the
 * request layer knows which API answered.
 */
export const fromLegacySshKey = (key: LegacySshKey): SshKey => ({
  id: key.key_id,
  value: key.value,
  label: key.title
});

export const addLegacySshKeyRequest = ({
  value,
  title
}: {
  value: string;
  title: string | null;
}) => apiProxyRequest<LegacySshKey>(`/ssh_keys`, "POST", { value, title });

export const deleteLegacySshKeyRequest = (keyId: string) =>
  apiProxyRequest(`/ssh_keys/${keyId}`, "DELETE");
